export interface ContainerTileConfig {
  id: string;
  title: string;
  description: string;
  icon: string;
  color: string;
  route: string;
}

export class ContainerTile {
  private element: HTMLElement;
  private config: ContainerTileConfig;

  constructor(config: ContainerTileConfig) {
    this.config = config;
    this.element = this.createTile();
  }

  private createTile(): HTMLElement {
    const tile = document.createElement('div');
    tile.className = 'container-tile fade-in';


    // Create icon
    const icon = document.createElement('div');
    icon.className = 'container-icon';
    icon.innerHTML = this.config.icon;

    // Create title
    const title = document.createElement('h2');
    title.className = 'container-title';
    title.textContent = this.config.title;

    // Create description
    const description = document.createElement('p');
    description.className = 'container-description';
    description.textContent = this.config.description;

    // Add click handler
    tile.addEventListener('click', () => {
      this.navigateToContainer();
    });

    // Add touch handler for better mobile experience
    tile.addEventListener('touchend', (e) => {
      e.preventDefault();
      this.navigateToContainer();
    });

    // Add touch feedback for better mobile interaction
    tile.addEventListener('touchstart', () => {
      tile.style.transform = 'scale(0.98)';
    });

    tile.addEventListener('touchcancel', () => {
      tile.style.transform = '';
    });

    // Assemble tile
    tile.appendChild(icon);
    tile.appendChild(title);
    tile.appendChild(description);

    return tile;
  }

  private navigateToContainer(): void {
    // Navigate to the container route
    window.location.href = this.config.route;
  }

  public getElement(): HTMLElement {
    return this.element;
  }

  public destroy(): void {
    // Clean up event listeners if needed
    this.element.remove();
  }
}
